import { AuthToken } from '@bioliberty/lifemind';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { RESET_ALL_ACTION } from '../actions';

type AuthState = {
  token?: AuthToken;
};

const initialState = {
  token: undefined
} as AuthState;

const slice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) => builder.addCase(RESET_ALL_ACTION, () => initialState),
  reducers: {
    setToken: (state, { payload: token }: PayloadAction<AuthToken | undefined>) => {
      state.token = token;
    }
  }
});

export const { setToken } = slice.actions;

export default slice.reducer;

export const getToken = (state: RootState): AuthToken | undefined => state.auth.token;

export const getRefreshToken = (state: RootState): string | undefined => state.auth.token?.refreshToken;
